<form [formGroup]="rootForm" *ngIf="! currentControl.disabled">
    <div class="form-group form-row mx-1">
        <label [for]="idHtml" class="form-label">{{libelle$ | async }} </label>
        <p class="text-muted" *ngIf="currentControl.value.length > 0"> ({{ currentControl.value.length }} choix sélectionnés)</p>
        <select  [formControlName]="label" [class.is-warning]="aErreurCroiseeActive()"
            [class.is-invalid]="champInvalide()" [class.is-valid]="champValide()" class="custom-select" [id]="idHtml" multiple>
            <option *ngFor="let modalite of modalites$ | async" [value]="modalite.code">{{ modalite.libelle }}</option>
        </select>
        <bis-affiche-erreurs class="col-12" *ngIf="erreursAffichable()" [erreurs]="rootForm.get(label).errors">
        </bis-affiche-erreurs>
    </div>
</form>